import React from "react";

const ColorSelector = ({ index, color = "#ffffff", setColor }) => {
  const handleColorChange = (event) => {
    setColor(event.target.value);
  };

  const colors = [
    { name: "Blanc", value: "#ffffff" },
    { name: "Gris clair", value: "#e3e3e3" },
    { name: "Bleu clair", value: "#00adef" },
  ];

  return (
    <div style={{ padding: "20px", backgroundColor: color }}>
      <h3>Choisir la couleur de fond :</h3>
      <div style={{ marginTop: "10px" }}>
        {colors.map((c, idx) => (
          <label key={idx} style={{ marginLeft: idx === 0 ? 0 : "10px" }}>
            <input
              type="radio"
              name={`bgColor${index}`}
              value={c.value}
              checked={color === c.value}
              onChange={handleColorChange}
            />
            {c.name}
          </label>
        ))}
      </div>
    </div>
  );
};

export default ColorSelector;
